import React, { Component } from 'react';
import CDATA from '../../Services/CDATA';
import AppContext from '../../AppContext';
import { InsRawResultsView, InsRawResultsBody } from './InsProdRawCalcResults.styles';
// import AppContext from '../../AppContext';
import GrpToolbar from '../../Library/GrpToolbar/GrpToolbar';
import GrpGrid from '../../Library/GrpGrid/GrpGrid';
import GrpSpinner from '../../Components/GrpSpinner/GrpSpinner';
import GrpError from '../../Components/GrpError/GrpError';
import GrpButton from '../../Library/GrpButton/GrpButton';
import { renderWithPermissions } from '../../Components/Auth0/permissionFunctions';
import { permissionTypes } from '../../Constants/Auth0Constants';


class InsProdRawCalcResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      api_name: this.props.api_name,
      loading: true,
      failed: false,
      toolbarButtons: [
        renderWithPermissions(() => <GrpButton
          text="Delete"
          type="Primary"
          onClick={() => { this.runDeleteResults(); }}
        />, permissionTypes.delete, () => <></>),
          <GrpButton
              onClick={() => { this.refreshData(); }}
              icon={['fas', 'sync']}
              iconSide="Round"
              size="Small"
          />,
      ],
    };
  }

  componentDidMount() {
    this.setState({
      post_data: {
        ClientCode: this.context.state.selectedClient.code,
        ReportingPeriod: this.context.state.selectedReportingDate.code,
      },
    });
    this.getMetadata();
  }

  async getMetadata() {
    try {
      const columns = await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_GET_COLUMNS',
        '',
        {
          API_NAME: this.state.api_name,
          MERGE_QUEUE_ID: -99,
        },
        'Error retrieving column names and metadata.',
      );

      this.setState({
        columnDefs: this.mapColumns(columns.value),
        rawColumns: columns.value,
      });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading the columns for this table. Please try again. If the issue persists, contact your administrator.',
      });
      console.log(err);
    }
  }

  async getData() {
    this.setState({ loading: true });
    try {
      this.gridApi.updateGridOptions({ rowData:[]});
      const data = await CDATA.makeRequest(
        'POST',
        this.state.api_name,
        '',
        this.state.post_data,
        'Error retrieving data.',
      );
      const totalRowCount = data && data['@odata.count'] !== 0 ? data['@odata.count'] : data.value.filter((item) => item.return_value !== '0').length;
      const rowData = [];
      this.gridApi.forEachNode((node) => rowData.push(node.data));
      setTimeout(
        ()=>{
          if(JSON.stringify(rowData) !== JSON.stringify(data.value.filter((item) => item.return_value !== '0')))
            this.gridApi.updateGridOptions({ rowData: data.value.filter((item) => item.return_value !== '0')});
        },
        10,
      );
      this.setState({ loading: false, totalRowCount });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  mapColumns = (rawColumns) => rawColumns.map((x) => ({
    field: x.dv_column,
    headerName: x.display_name,
    hide: x.is_hidden,
    editable: x.editable,
    comparator: x.sorttype !== undefined && x.sorttype.toLowerCase() === 'numeric' && ((value1, value2) => (value1 - value2)),
    // this is if you want to do a default sort for a specific column
    // sort: this.props.defaultGridSort !== undefined && this.props.defaultGridSort.toLowerCase() === x.dv_column.toLowerCase() ? {
    //   direction: 'desc',
    //   priority: 0
    // } : null,
  }));

  runDeleteResults = () => {
    const modalContent = (
      <div>
        {`Do you want to delete all record for reporting date: ${this.context.state.selectedReportingDate.code}`}
      </div>
    );
    const modalFooter = (
      <div>
        <GrpButton
          onClick={() => this.deleteResults()}
          size="Medium"
          type="Primary"
          text="Delete"
        />
        <GrpButton
          onClick={() => this.context.handlers.toggleModal()}
          size="Medium"
          type="Secondary"
          text="Cancel"
        />
      </div>
    );
    this.context.handlers.setModal('Delete', modalContent, null, modalFooter, false);
    this.context.handlers.toggleModal();
  }

  deleteResults = () => {
    CDATA.makeRequest(
      'POST',
      'PRIIPS_app_DELETE_CALC_OUTPUTS',
      '',
      {
        ClientCode: this.context.state.selectedClient.code,
        ReportingPeriod:this.context.state.selectedReportingDate.code,
      }
    )
    .then(() => {
      this.context.handlers.closeModal();
      const toast = {
        type: 'success',
        body: (
          <>
            {'You successfully deleted all calc results for: '}
            <span>{this.context.state.selectedReportingDate.code}</span>
            {' Please Refresh.'}
          </>
        ),
      };
      this.context.handlers.setToast(toast);
    })
    .catch(() => {
      this.context.handlers.closeModal();
      const toast = {
        type: 'error',
        body: (
          <>
            {'Error something went wrong and we were not able to delete calc results for: '}
            <span>{this.context.state.selectedReportingDate.code}</span>
          </>
        )
      }
    })
  }

  onGridReady = async (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.getData();
  };

  onModelUpdated = (params) => {
    if(this.state.displayedRowCount !== params.api.getDisplayedRowCount())
      this.setState({ displayedRowCount: params.api.getDisplayedRowCount() });
  }

    refreshData() {
        this.setState({ loading: true }, () => this.getData());
    }

  render() {
    return (
      <InsRawResultsView>
        <InsRawResultsBody>
          {
            this.state.failed ? <GrpError text={this.state.failMessage} /> : (
              <>
                {
                  this.state.loading ? <GrpSpinner text="Loading data..." /> : (
                    this.gridApi && (
                      <GrpToolbar
                        api={this.gridApi}
                        working={this.state.toolbarWorking}
                        controls={this.state.toolbarButtons}
                        exportName={this.state.api_name}
                        count={{
                          total: this.state.totalRowCount,
                          showing: this.state.displayedRowCount,
                        }}
                      />
                    )
                  )
                }

                <GrpGrid
                  columnDefs={this.state.columnDefs}
                  rawColumnData={this.state.rawColumns}
                  onGridReady={this.onGridReady}
                  apiName={this.state.api_name}
                  onModelUpdated={this.onModelUpdated}
                  pivotable
                />
              </>
            )
          }
        </InsRawResultsBody>
      </InsRawResultsView>
    );
  }
}

InsProdRawCalcResults.contextType = AppContext;

export default InsProdRawCalcResults;
